import { PacoteCampanhaSelect } from './pacote-campanha-select';

export class AreaPacoteCampanhaSelect {
    id: number;
    nome: string;
    private _pacotes: PacoteCampanhaSelect[];

    constructor(id: number, nome: string) {
        this.id = id;
        this.nome = nome;
        this._pacotes = [];
    }

    /** Pacotes da área */
    get pacotes(): PacoteCampanhaSelect[] {
        return this._pacotes;
    }

    /** Adiciona um pacote à área */
    addPacote(pacote: PacoteCampanhaSelect) {
        this._pacotes.push(pacote);
    }

    /** Verifica se a área possui o pacote informado */
    hasPacote(idPacote: number): boolean {
        const pacote = this.findPacote(idPacote);
        return pacote != null && pacote !== undefined;
    }

    /** Procura o pacote informado na área */
    findPacote(idPacote: number): PacoteCampanhaSelect {
        return this._pacotes?.find(pacoteFilter => pacoteFilter.id === idPacote);
    }
}

/** Obtem a área do pacote no array de áreas de pacotes através do id informado */
export function findAreaPacote(areasPacotes: AreaPacoteCampanhaSelect[], idArea: number): AreaPacoteCampanhaSelect {
    if (!areasPacotes) {
        return null;
    }
    return areasPacotes?.find(areaFilter => areaFilter.id === idArea);
}

/** Cria os options do select agrupando os pacotes pelas suas áreas */
export function createAreasPacotesSelect(pacotes: PacoteCampanhaSelect[]): AreaPacoteCampanhaSelect[] {
    const areasPacotes = [];
    if (!pacotes) {
        return;
    }

    // Pacotes pesquisados
    for (let i = 0; i < pacotes.length; i++) {
        const pacote = pacotes[i];

        // Obtendo a área do pacote
        let area = findAreaPacote(areasPacotes, pacote.idArea);

        // Se não encontrar a área no array de áreas, então criamos ele através do pacote
        if (!area) {
            area = new AreaPacoteCampanhaSelect(pacote.idArea, pacote.nomeArea);
            areasPacotes.push(area);
        }

        // Adicionando o pacote à sua área
        area.addPacote(pacote);
    }

    return areasPacotes;
}
